<template>
  <div class="sky-input">
    <itemSearch  v-bind="$attrs">
      <el-input :value="_selfData" @change="change" v-bind="$attrs" ref="input"></el-input>
      <div slot="toolTips">{{toolContent}}</div>
    </itemSearch>
  </div>
</template>
<script>
import itemSearch from '@/components/iglobalwin/formComponents/SkySuffix.vue'
import formStore from '@/mixins/formStore.js'
export default {
  name: 'sky-input',
  props: ['value', 'toolContent'],
  mixins: [formStore],
  inheritAttrs: false,
  data () {
    return {
      val: ''
    }
  },
  methods: {
    change (val) {
      this.$emit('input', val)
    }

  },
  watch: {
    value(val){
      this.val = val
    }
  },
  components: {itemSearch}
}
</script>
<style scoped lang="scss">

</style>
